import { getApi } from "./api_instance";

const getRegitryandExpiryTime = async (logout) => {
  try {
    return await getApi({
      apiUrl: `/admin/projects/api/offsetgo-data`,
      sendToken: true,
      logout,
    });
  } catch (error) {
    throw error;
  }
};

export default getRegitryandExpiryTime;
